import { useState } from 'react';
import { PROVIDER_MODELS } from '../../constants/llmProviders';

interface ModelSelectProps { provider: string; value: string; onChange: (v: string) => void; }

export default function ModelSelect({ provider, value, onChange }: ModelSelectProps) {
  const models  = PROVIDER_MODELS[provider] || [];
  const isKnown = models.some(m => m.value === value);
  const [custom, setCustom] = useState(!isKnown && value !== '');

  function handleSelectChange(e: React.ChangeEvent<HTMLSelectElement>) {
    if (e.target.value === '__custom__') { setCustom(true); onChange(''); }
    else { setCustom(false); onChange(e.target.value); }
  }

  return (
    <div className="form-group">
      <label>Model</label>
      {models.length > 0 && !custom ? (
        <select className="form-input" value={isKnown ? value : ''} onChange={handleSelectChange}>
          <option value="">— Select a model —</option>
          {models.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          <option value="__custom__">Custom model ID…</option>
        </select>
      ) : (
        <div className="input-wrapper">
          <input
            className="form-input"
            placeholder="Enter model ID"
            value={value}
            onChange={e => onChange(e.target.value)}
          />
          {models.length > 0 && (
            <button type="button" className="input-reveal" onClick={() => { setCustom(false); onChange(''); }}>
              List
            </button>
          )}
        </div>
      )}
    </div>
  );
}
